export default function StepperProgramados({ activeStep }) {
  const steps = [
    {
      title: 'Plantilla',
      description: ''
    },
    {
      title: 'Previsualización',
      description: 'Revisa y edita los documentos antes de programarlos.'
    },
    {
      title: 'Procesamiento',
      description: 'Estamos configurando tus programaciones en el sistema.'
    },
    {
      title: 'Reporte',
      description: 'Resultado final de la carga de programaciones y detalle de éxitos/errores.'
    }
  ]

  const currentStep = steps[activeStep] || steps[0]

  return (
    <div className='flex flex-col items-center justify-center bg-white mt-3'>
      {/* Píldora de encabezado */}
      <div className='inline-flex items-center justify-center px-6 py-1.5 rounded-full bg-slate-50 border border-slate-200 shadow-sm mb-3'>
        <span className='text-[13px] font-bold text-slate-800 tracking-tight'>
          Paso {activeStep + 1} de {steps.length} - {currentStep.title}
        </span>
      </div>

      {/* Descripción secundaria */}
      <p className='text-xs text-slate-500 text-center max-w-xl leading-relaxed'>
        {currentStep.description}
      </p>
    </div>
  )
}
